// PLUGINS IMPORTS //
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { NavigationItemType } from "../../SideNavigation"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  item: NavigationItemType
  setOpen: (open: boolean) => void
}

const NavItem: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      <Link to={props.item.dest} onClick={() => props.setOpen(false)}>
        {props.item.title}
      </Link>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const PADDING_VERTICAL = "20px"
const Wrapper = styled.li`
  color: black;
  padding-top: ${PADDING_VERTICAL};
  padding-bottom: ${PADDING_VERTICAL};
  padding-left: 16px;
  font-weight: bold;
  font-size: 16px;
`

export default React.memo(NavItem, memoComparison)
